import _ from 'lodash';
import moment from 'moment';
import XLSX_STYLE from 'xlsx-js-style';
import ExportExcelTemplate from './ExportRepaymentExcelTemplate';

export default {
    methods: {
        async onExport() {
            const wb = XLSX_STYLE.utils.book_new();
            const ws = this.getExcelSheet(this.data.repaymentList);

            XLSX_STYLE.utils.book_append_sheet(wb, ws, '還款明細');
            XLSX_STYLE.writeFile(wb, `${this.data.summary}-動撥${this.data.amount}-還款明細-${moment().format('YYYYMMDD')}.xlsx`);
        },
        getExportDataRows(deatils) {
            return _.map(deatils, (o, i) => ({
                A: i + 1,
                B: o.repaymentDate ? moment(o.repaymentDate).format('YYYY-MM-DD') : '---',
                C: o.principalAmount,
                D: o.interestAmount,
                E: o.totalAmount,
                F: o.balance,
                G: o.repaymentBankName,
                H: o.note || '',
            }));
        },
        getExcelSheet(deatils) {
            const DATA = this.getExportDataRows(deatils);

            const sheet = _.cloneDeep(ExportExcelTemplate);

            XLSX_STYLE.utils.sheet_add_json(sheet, DATA, { skipHeader: true, origin: 'A2' });

            const widthSettings = [4, 10, 15, 10, 8, 15, 10, 15];
            sheet['!cols'] = _.map(widthSettings, (h) => ({ wch: h }));

            _.forEach(sheet, (value, key) => {
                if (!key.includes('!')) {
                    const COL = key.substring(0, 1);

                    if (sheet[key].s) {
                        sheet[key].s.border = {
                            bottom: { style: 'thin', color: 'FFFFFFFF' },
                            top: { style: 'thin', color: 'FFFFFFFF' },
                            left: { style: 'thin', color: 'FFFFFFFF' },
                            right: { style: 'thin', color: 'FFFFFFFF' },
                        };
                    } else {
                        sheet[key].s = {
                            border: {
                                bottom: { style: 'thin', color: 'FFFFFFFF' },
                                top: { style: 'thin', color: 'FFFFFFFF' },
                                left: { style: 'thin', color: 'FFFFFFFF' },
                                right: { style: 'thin', color: 'FFFFFFFF' },
                            },
                        };
                    }

                    if (COL === 'A' || COL === 'B' || COL === 'G' || COL === 'H') sheet[key].s.alignment = { horizontal: 'left' };
                    else sheet[key].s.alignment = { horizontal: 'right' };

                    // 設定金額格式
                    if (COL === 'C' || COL === 'D' || COL === 'E' || COL === 'F') sheet[key].z = '#,##0_-;-#,##0_-;0;General';
                }
            });

            return sheet;
        },
    },
};
